import React, { useState } from 'react'
import { Box, TextField, Typography } from '@mui/material'
import dayjs, { Dayjs } from 'dayjs'
import { useSession } from 'next-auth/react'

import { ButtonGray, ButtonUI, Error, InputStyleDark, Loader, Modal } from '#/shared'
import { accountApi } from '#/shared/api/account-endpoints'
import { useShowDataStore } from '#/shared/lib/hooks/use-show-data'
import { DateInput } from '#/shared/ui/date-input/date-input'

import styles from '../invite-person-in-business/ui/invite-modal.module.scss'

export const ApiKeyModal = ({
	open,
	setOpen,
	keys,
	setKeys,
}: {
	open: boolean
	setOpen: React.Dispatch<React.SetStateAction<boolean>>
	keys: any[] | null
	setKeys: React.Dispatch<React.SetStateAction<any[] | null>>
}) => {
	const [endDate, setEndDate] = useState<string | Dayjs>()
	const [title, setTitle] = useState<string>('')

	const [isLoading, setIsLoading] = useState(false)

	const { data, status } = useSession()
	const { showMessage } = useShowDataStore()

	const createKey = async () => {
		if (keys === null || status !== 'authenticated') {
			return
		}

		const keyName = `Ключ ${Math.floor(Math.random() * 100000) + 1}`

		if (endDate && dayjs(endDate).isBefore(dayjs(), 'day')) {
			showMessage('Указана неверная дата')
			return
		}

		setIsLoading(true)
		const response =
			endDate && endDate !== ''
				? await accountApi.createApiKeys(
						{ name: title !== '' ? title : keyName, expires_at: endDate },
						data?.access
				  )
				: await accountApi.createApiKeys({ name: title !== '' ? title : keyName }, data?.access)
		
		if (response.status >= 400 && response.data?.detail) {
			showMessage(response.data.detail)
			setIsLoading(false)
			return
		}

		if (response.status >= 200 && response.status < 300) {
			const keysResponse = await accountApi.getApiKeys(data?.access)
			if (keysResponse.status >= 400 && keysResponse.data?.detail) {
				showMessage(keysResponse.data.detail)
				setIsLoading(false)
				return
			} else if (keysResponse.status >= 200 && keysResponse.status < 300) {
				setKeys(keysResponse.data)
			} else {
				showMessage('Ошибка при получении API ключей')
				setIsLoading(false)
				return
			}
		} else {
			showMessage('Ошибка при создании API ключа')
			setIsLoading(false)
			return
		}

		setOpen(false)
		setTitle('')
		setEndDate('')
		setIsLoading(false)
	}

	return (
		<Modal open={open} onClose={() => setOpen(false)}>
			<form>
				<Box className={styles.wrap}>
					<Typography className={styles.title}>Параметры ключа</Typography>

					<Box className={styles.modalWrap}>
						<Typography sx={{ marginBottom: '10px' }} className={styles.hint}>
							Название ключа
						</Typography>
						<TextField
							value={title}
							type='email'
							placeholder={'Введите название ключа'}
							onChange={(e) => setTitle(e.target.value)}
							fullWidth
						sx={{ ...InputStyleDark }}
						/>

						<Typography sx={{ marginBottom: '10px' }} className={styles.hint}>
							Действителен до:
						</Typography>
						<DateInput setDate={setEndDate} />
					</Box>

					{isLoading ? (
						<Box width='100%' marginTop={1} textAlign='center'>
							<Loader />
						</Box>
					) : (
						<Box className={styles.buttons}>
							<Box>
								<ButtonGray onClick={() => setOpen(false)} text='Отмена' />
							</Box>
							<ButtonUI onClick={createKey} text='Создать ключ' />
						</Box>
					)}
				</Box>
			</form>
		</Modal>
	)
}
